import { z } from 'zod';
import { ExperienceStepSchema } from './Experience.schema';
import { ExtrasSchema } from './Extra.schema';
import { GuestFieldFormSchema } from './Guest.schema';
import { SelectExperienceSchema } from './SelectExperience.schema';
import { TablesSchema } from './Tables.schema';
import { SpaExtrasSchema } from './SpaExtra.schema';

export const PackagesSchema = z.object({
  guests: GuestFieldFormSchema,
  extras: ExtrasSchema,
  experiences: ExperienceStepSchema,
  tables: TablesSchema.optional(),
  selectedExperiences: SelectExperienceSchema.optional(),
  visitDate: z.string(),
  spaExtras: SpaExtrasSchema,
});

export type PackagesFormValues = z.infer<typeof PackagesSchema>;
